<select
  class="form-select"
  [class.is-invalid]="showError"
  [id]="id"
  [required]="props['required']"
  [formControl]="formControl"
  [formlyAttributes]="field"
  (keydown)="onKeydown($event)">

  <option *ngIf="props['placeholder']" [ngValue]="undefined">
    {{ props['placeholder'] }}
  </option>

  <ng-container *ngFor="let opt of (props['options'] | formlySelectOptions: field | async)">
    <ng-container *ngIf="opt.group; else singleOption">
      <optgroup [label]="opt.label">
        <option
          *ngFor="let o of opt.options"
          [ngValue]="o.value"
          [disabled]="o.disabled">
          {{ o.label }}
        </option>
      </optgroup>
    </ng-container>
    <ng-template #singleOption>
      <option
        [ngValue]="opt.value"
        [disabled]="opt.disabled">
        {{ opt.label }}
      </option>
    </ng-template>
  </ng-container>
</select>
